import { config } from "dotenv";
import moment from "moment";
import deepOrange from "@material-ui/core/colors/deepOrange";
import deepPurple from "@material-ui/core/colors/deepPurple";
import blue from "@material-ui/core/colors/blue";
import yellow from "@material-ui/core/colors/yellow";
config();
const isLocal = true;
const isConfig_Local = false;
export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "/api"
    : `http://${isLocal ? "localhost:9001" : "129.232.134.66"}/api`;
export const CONFIGURATION_BASE_URL = isConfig_Local
  ? "http://localhost:3006"
  : "https://segapp.co.za/config";
export const PHONE_REG_EXP = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/; // for Mobile Numbers
export const EMAIL_REG_EXP = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/;

export const INTERVAL_TIME = 15;

export enum GRAPHS {
  QUESTIONNAIRE = "QUESTIONNAIRE",
  TEMPERATURE_MEASUREMENT = "TEMPERATURE_MEASUREMENT",
  PERSONS_SCREENED = "PERSONS_SCREENED",
  DAILY_TEMPERATURE = "DAILY_TEMPERATURE",
  DAILY_TEMPERATURE_CONNECT = "DAILY_TEMPERATURE_CONNECT",
}
export enum MAIN_TYPES {
  AUDIT = "AUDIT",
  PERSONAL = "PERSONAL",
  MACHINE_INSPECTION = "MACHINE_INSPECTION",
  PRE_USE_INSPECTION = "PRE-USE-INSPECTION",
  PRE_USE_INSPECTION_DASH = "PRE-USE INSPECTION",
  WORK_FLOW = "WORK-FLOW",
  WORKFLOW = "WORKFLOW",
}
export enum INSPECTION_CAPTURE_TYPES {
  NORMAL = "NORMAL",
  WORKFLOW = "WORKFLOW",
}
class HasAccessPermission {
  static accessRules = [];
}
export default HasAccessPermission;
export enum MOD_GRAPHS {
  STATISTIC = "STATISTIC",
  SCREENING_STATUS = "SCREENING_STATUS",
  TEMPERATURE_MEASUREMENT = "TEMPERATURE_MEASUREMENT",
  CASES_BY_DEPARTMENT = "CASES_BY_DEPARTMENT",
  CASES_BY_COMPANY = "CASES_BY_COMPANY",
  SCREENING_QUESTIONNAIRE_FEEDBACK = "SCREENING_QUESTIONNAIRE_FEEDBACK",
}
export enum GRAPH_TYPES {
  TABLE = "TABLE",
  LINE = "LINE",
  PIE = "PIE",
  BAR = "BAR",
}
export enum FILTER_TYPES {
  EVERY_DAY = "every day",
  EVERY_WEEK = "every week",
  EVERY_MONTH = "every month",
  EVERY_YEAR = "every year",
}
export enum RESULT_STATUS {
  PASSED = "PASSED",
  FAILED = "FAILED",
}
export enum ROLES {
  ADMIN = "ADMIN",
  KRODAC_ADMIN = "KRODAC_ADMIN",
  DASHBOARD = "DASHBOARD",
  VIEW = "VIEW",
  SUPER_VIEW = "SUPER_VIEW",
  MANAGER = "MANAGER",
  VISITOR = "VISITOR",
  SUPER_USER = "SUPER_USER",
  INSPECTOR = "INSPECTOR",
}

export enum NOTIFICATION_TYPES {
  EMAIL = "EMAIL",
  SMS = "SMS",
}


export enum ACTIVITY_FLOW_TYPES {
  SERVICE = "S",
  WAITING = "X",
  MAINTENANCE = "B",
  TRAVELLING = "T",
  LOADING = "L",
  PRECHECK = "P"
}
export enum ORITATIONS {
  VERTICAL = "VERTICAL",
  HORIZONTAL = "HORIZONTAL",
}

export const LEGEND_TYPES = [
  {
    value: "LEGEND_A",
    color: "red",
    textColor: "white",
    label: "Legend A",
  },
  {
    value: "LEGEND_B",
    color: "yellow",
    textColor: "black",
    label: "Legend B",
  },
  {
    value: "LEGEND_C",
    color: "green",
    textColor: "white",
    label: "Legend C",
  },
];
export const ROLE_TYPES = [
  {
    value: "SUPER_USER",
    label: "Super User",
  },
  {
    value: "MANAGER",
    label: "Manager",
  },
  {
    value: "VIEW",
    label: "View",
  },
  {
    value: "SUPER_VIEW",
    label: "Super View",
  },
  {
    value: "DASHBOARD",
    label: "Dashboard",
  },
];
export const FORM_RESPONSE_TYPES = [
  {
    title: "TEXT",
    label: "Text (Free Text)",
  },
  {
    title: "BARCODE",
    label: "Barcode",
  },
  {
    title: "NUMBER",
    label: "Number (Digit only)",
  },
  {
    title: "SIGNATURE",
    label: "Signature",
  },
  {
    title: "Options",
    label: "Retrieve Options",
  },
];
export const SEARCH_TYPES = [
  {
    label: "Identity Number",
    value: "identityNumber",
  },
  {
    label: "Passport Number",
    value: "passportNumber",
  },
  {
    label: "Employee/Company Number",
    value: "employeeNumber",
  },
  {
    label: "Barcode",
    value: "barcode",
  },
  {
    label: "Serial Number",
    value: "serialNumber",
  },
  {
    label: "SKU Code",
    value: "skuCode",
  },
];

export const POPUP_TRIGGERS_ACTIONS = [
  {
    label: "Logout",
    value: "logout",
  },
  {
    label: "Next",
    value: "next",
  },
  {
    label: "Back",
    value: "back",
  },
]

export const POPUP_TRIGGERS = [
  {
    label: "Boarding",
    value: "Boarding",
  },
  {
    label: "Login",
    value: "Login",
  },
  {
    label: "Home",
    value: "Home",
  },
  {
    label: "Inspection Types",
    value: "filter",
  },
  {
    label: "Categories",
    value: "InspectionCategories",
  },
  {
    label: "Create Inspection",
    value: "InspectionTypes",
  },
  {
    label: "Inspection",
    value: "MainInspections",
  },
  {
    label: "Results",
    value: "Results",
  },
  {
    label: "Success",
    value: "Success",
  },
];

export const PRIMITIVE_TYPES = [
  {
    label: "None",
    value: "none",
    type: "",
    length: -1,
  },
  {
    label: "Identity Number",
    value: "idenityNumber",
    type: "number",
    length: 13,
  },
  {
    label: "Passport Number",
    value: "passportNumber",
    type: "alphaNumeric",
    length: 9,
  },
  {
    label: "Tell/Cell Number",
    value: "cellNumber",
    type: "number",
    length: 10,
  },
  {
    label: "Date",
    value: "date",
    type: "date",
    length: -1,
  },
  {
    label: "Email",
    value: "email",
    type: "email",
    length: -1,
  },
  {
    label: "Time",
    value: "time",
    type: "time",
    length: -1,
  },
];

export const SIGNATURE_TYPES = [
  {
    label: "Hand Signature Only",
    value: "handSignatureOnly",
  },
  {
    label: "Employee Number and Hand Signature",
    value: "handSignature",
  },
  {
    label: "Employee/Company Number",
    value: "employeeNumber",
  },
];
export const FREQUENCIES = [
  { label: "Daily", value: "DAILY" },
  { label: "Weekly", value: "WEEKLY" },
  { label: "Monthly", value: "MONTHLY" },
  { label: "Custom", value: "CUSTOM" },
]

export const REPEAT_FREQUENCIES = [
  { label: "Day", value: "DAY" },
  { label: "Week", value: "WEEK" },
  { label: "Month", value: "MONTH" },
]

export const RETRIEVE_FROM = [
  {
    value: "none",
    label: "None",
  },
  {
    value: "fullName",
    label: "Full Name",
  },
  {
    value: "employeeNumber",
    label: "Employee Number",
  },
  {
    value: "contactNumber",
    label: "Contact Number",
  },
  {
    value: "emailAddress",
    label: "Email Address",
  },
  {
    value: "companyName",
    label: "Company Name",
  },
  {
    value: "position",
    label: "Position",
  },
  {
    value: "department",
    label: "Department",
  },
  {
    value: "section",
    label: "Section",
  },
  {
    value: "identityNumber",
    label: "Identity Number",
  },
  {
    value: "passportNumber",
    label: "Passport Number",
  },
  {
    value: "gender",
    label: "Gender",
  },
  {
    value: "ethnicity",
    label: "Ethnicity",
  },
  {
    value: "radius",
    label: "Radius",
  },
  {
    value: "licenseDetails",
    label: "License Details",
  },
  {
    value: "options",
    label: "Retrieve Options",
  },
];


export const WAREHOUSE_CONTENT_RETRIEVE_FROM = [
  {
    value: "none",
    label: "None",
  },
  {
    value: "type",
    label: "Type",
  },
  {
    value: "itemName",
    label: "Item Name",
  },
  {
    value: "skuCode",
    label: "SKU Code",
  },
  {
    value: "barcode",
    label: "Barcode",
  },
  {
    value: "unitOfMeasurement",
    label: "Unit of Measurement",
  },
  {
    value: "dimensionL",
    label: "Dimension Length",
  },
  {
    value: "dimensionW",
    label: "Dimension Width",
  },
  {
    value: "dimensionH",
    label: "Dimension Height",
  },
  {
    value: "weight",
    label: "Weight",
  },
  {
    value: "weightUnit",
    label: "Weight Unit",
  },
  {
    value: "manufacturer",
    label: "Manufacturer",
  },
  {
    value: "serialNumber",
    label: "Serial Number",
  },
  {
    value: "salesSellingPrice",
    label: "Sales Selling Price",
  },
  {
    value: "salesTax",
    label: "Sales Tax",
  },
  {
    value: "purchasePrice",
    label: "Purchase Price",
  },
  {
    value: "reOrderPoint",
    label: "Re-Oder Point",
  },
  {
    value: "quantityOnHand",
    label: "Quantity On Hand",
  },
  {
    value: "changesOnQuantity",
    label: "Change On Quantity",
  },
  {
    value: "preferredSupplier",
    label: "Preferred Supplier",
  },
  {
    value: "wareHouseName",
    label: "WareHouse Name",
  },
  {
    value: "warehouseOpenStock",
    label: "Warehouse OpenStock",
  },
  {
    value: "warehouseOpenStockValue",
    label: "Warehouse OpenStock Value",
  },
];

export const APPLICATION_TYPE = [
  {
    value: "segpi",
    label: "Segpi",
  },
  {
    value: "wms",
    label: "Segwms",
  },
]

export const WMS_OPERATION_TYPE = [
  {
    value: "issuing",
    label: "Issuing",
  },
  {
    value: "receiving",
    label: "Receiving",
  },
]


export const DAYS_OF_MONTH = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
];

export const OPTIONS = ["Required", "Optional", "Complete later"];
export const RESPONSE_TYPES = [
  {
    title: "TEXT",
    label: "Text (YES/NO)",
    response: {
      positive: "YES",
      negative: "NO",
      positiveColor: "black",
      negativeColor: "black",
    },
  },
  {
    title: "TEXT_2",
    label: "Text (YES)",
    response: {
      positive: "YES",
      positiveColor: "black",
    },
  },
  {
    title: "TEXT_3",
    label: "Text (NO)",
    response: {
      negative: "NO",
      negativeColor: "black",
    },
  },
  {
    title: "CHECK_1",
    label: "Check (GO/NO-BUT)",
    response: {
      positive: "GO",
      negative: "NO-BUT",
      positiveColor: "black",
      negativeColor: "black",
    },
  },
  {
    title: "CHECK_2",
    label: "Check (GO/NO-GO)",
    response: {
      positive: "GO",
      negative: "NO-GO",
      positiveColor: "black",
      negativeColor: "black",
    },
  },
  {
    title: "CHECK_4",
    label: "Check (OK/NO-OK)",
    response: {
      positive: "OK",
      negative: "NO-OK",
      positiveColor: "black",
      negativeColor: "black",
    },
  },
  {
    title: "CHECK_5",
    label: "Check (GO)",
    response: {
      positive: "GO",
      positiveColor: "black",
    },
  },
  {
    title: "CHECK_6",
    label: "Check (NO-GO)",
    response: {
      negative: "NO-GO",
      negativeColor: "black",
    },
  },
  {
    title: "CHECK_7",
    label: "Check (OK)",
    response: {
      positive: "OK",
      positiveColor: "black",
    },
  },
  {
    title: "CHECK_8",
    label: "Check (NO-OK)",
    response: {
      negative: "NO-OK",
      negativeColor: "black",
    },
  },
  {
    title: "INTERACTIVE_1",
    label: "Interactive (GO/GO-BUT)",
    response: {
      positive: "GO",
      negative: "GO-BUT",
      positiveColor: "black",
      negativeColor: "black",
    },
  },
  {
    title: "INTERACTIVE_2",
    label: "Interactive (GO/GO-BUT)",
    response: {
      positive: "GO",
      negative: "GO-BUT",
      positiveColor: "black",
      negativeColor: "black",
    },
  },
  {
    title: "INTERACTIVE_3",
    label: "Interactive (GO/NO-GO)",
    response: {
      positive: "GO",
      negative: "NO-GO",
      positiveColor: "black",
      negativeColor: "black",
    },
  },
  {
    title: "INTERACTIVE_4",
    label: "Interactive (YES/NO)",
    response: {
      positive: "YES",
      negative: "NO",
      positiveColor: "black",
      negativeColor: "black",
    },
  },
  {
    title: "INTERACTIVE_5",
    label: "Interactive (GO)",
    response: {
      positive: "GO",
      positiveColor: "black",
    },
  },
  {
    title: "INTERACTIVE_6",
    label: "Interactive (NO-GO)",
    response: {
      negative: "NO-GO",
      negativeColor: "black",
    },
  },
  {
    title: "INTERACTIVE_7",
    label: "Interactive (YES)",
    response: {
      positive: "YES",
      positiveColor: "black",
    },
  },
  {
    title: "INTERACTIVE_8",
    label: "Interactive (NO)",
    response: {
      negative: "NO",
      negativeColor: "black",
    },
  },
  {
    title: "COMMENT",
    label: "Comment (Free Text)",
  },
  {
    title: "NUMERIC",
    label: "Digits (Free Text)",
  },
  {
    title: "Options",
    label: "Retrive Options",
  },
];
export const POSITION_TYPES = [
  {
    value: "DRIVER",
    label: "Driver",
  },
  {
    value: "OPERATOR",
    label: "Operator",
  },
  {
    value: "SUPERVISOR",
    label: "Supervisor",
  },
  {
    value: "MANAGER",
    label: "Manager",
  },
  {
    value: "EMPLOYEE",
    label: "Employee",
  },
];

export const PROVINCES = [
  {
    value: "EC",
    label: "Eastern Cape",
  },
  {
    value: "WC",
    label: "Western Cape",
  },
  {
    value: "NC",
    label: "Northern Cape",
  },
  {
    value: "GP",
    label: "Gauteng",
  },
  {
    value: "MP",
    label: "Mpumalanga",
  },
  {
    value: "FS",
    label: "Free State",
  },
  {
    value: "NW",
    label: "North West",
  },
  {
    value: "KZN",
    label: "KwaZulu-Natal",
  },
  {
    value: "LP",
    label: "Limpopo",
  },
];

export const INSPECTION_CATEGORY = [
  {
    value: "VEHICLE_INSPECTION",
    label: "Vehicle",
  },
  {
    value: "MACHINE_INSPECTION",
    label: "Machine",
  },
  {
    value: "WORKING-AREA",
    label: "Work Area",
  },
  {
    value: "PERSONAL",
    label: "Personal*",
  },
];
export const INSPECTION_TYPES = [
  {
    value: "AUDIT",
    label: "Audit",
  },
  {
    value: "PRE-USE-CHECKLIST",
    label: "Pre-Use Checklist",
  },
  {
    value: "MAINTENANCE",
    label: "Maintenance",
  },
  {
    value: "OTHER",
    label: "Other",
  },
];
export const CAPTURE_TYPE = [
  {
    value: "QUESTIONS",
    label: "Questions",
  },
  {
    value: "FORMS",
    label: "Forms",
  },
];
export const DASHBOARD_TYPES = {
  AUDIT_PERSONAL: "ScreeningDashBoard",
  AUDIT_WORKSPACE: "WorkspaceDashBoard",
  PRE_USE_INSPECTION_EQUIPMENT_LHD: "LHDDashBoard",
  PRE_USE_INSPECTION_EQUIPMENT_DUMP_TRUCK: "DumpTruckDashBoard",
  PRE_USE_INSPECTION_EQUIPMENT_CONVEYOR_BELT: "ConveyorBeltBoard",
}

export const colors = {
  primaryColor: "#f96400",
};

export const COLOR_PICKER_COLORS = [
  { color: deepOrange[500], title: "Orange" },
  { color: deepPurple[500], title: "Purple" },
  {
    color: "#f9130b",
    title: "Red",
  },
  { color: "#0eb92d", title: "Green" },
  {
    color: blue[500],
    title: "Blue",
  },
  { color: yellow[500], title: "Yellow" },
];

export function getLegend(legendKey: any) {
  let legendResult = { color: "", label: "", textColor: "" };
  LEGEND_TYPES.map((item) => {
    if (legendKey === item.value) {
      legendResult = item;
    }
    return null;
  });
  return legendResult;
}
export const DRAGGABLE_KEY_TYPES = {
  DRAG_COMPONENT: "COMPONENT",
  TEXT_COMPONENT: "TEXT_COMPONENT"
};
export const EQUIPMENT_STATUS_DATE_FORMAT = "DD MMM YY"
export function getMomentDate(date: string, format = "DD MMMM YYYY") {
  let mDate = new Date(date);
  let momentDate = moment(mDate).format(format);
  return momentDate;
}
export function getMomentDateTime(date: string) {
  let momentDate = moment(new Date(date)).format("DD MMMM YYYY HH:mm A");
  return momentDate;
}
export function getMomentTime(timeArg: string) {
  var time = moment.utc(timeArg, "HH:mm:ss A");
  return time.format("HH:mm A");
}
export function isFloat(n: any) {
  n = n.length > 0 ? Number(n) : false;
  return (n === parseFloat(n));
};
export function isEmpty(obj: any) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}
export function titleCase(str: any) {
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word: any) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}
export function getInspectionLabel(inspectionKey: any, values: any) {
  if (!values) {
    return inspectionKey;
  }
  let inspectionResult = { value: "", label: "" };
  values.map((item: any) => {
    if (inspectionKey === item.value) {
      inspectionResult = item;
    }
    if (inspectionKey === item.value.replace(" ", "-")) {
      inspectionResult = item;
    }
    return null;
  });
  return inspectionResult;
}
export function getAcronym(value: any) {
  if (!value) {
    return null;
  }
  var matches = value.match(/\b(\w)/g);
  return matches ? matches.join("") : "";
}
export function getRoles(role: any, accessRules: any) {
  let roles = accessRules.filter((accessRuleItem: any) => {
    return accessRuleItem.role === role;
  });
  if (roles.length > 0) {
    return roles[0];
  } else {
    return null;
  }
}
export function getEquipmentTypes(equipments: any) {
  let equipmentsTypes = new Array<any>();
  equipments.map((item: any) => {
    let foundObj = equipmentsTypes.filter((obj: any) => { return obj.type === item.type });
    if (foundObj.length === 0) {
      equipmentsTypes.push(item);
    }
    return null;
  })
  return equipmentsTypes;
}
export function getCategories(inspectionTypes: any, inspectionType: any) {
  let categories = new Array<any>();
  let mInspectionsTypes = inspectionTypes.filter((item: any) => {
    return item.value === inspectionType;
  });
  return mInspectionsTypes.length > 0
    ? mInspectionsTypes[0].categories
    : categories;
};

export function convertTextToTitleCase(camelCaseText: any) {
  if (!camelCaseText) {
    return "";
  }
  let result = camelCaseText.split(' ')
    .map((word: any, index: any) => {
      // First character upper case else lower case
      let m = word.charAt(0)
        .toUpperCase() + word.slice(1)
          .toLowerCase();
      return m;
    })
    .join(' ');
  return result;
}

export function MULT(a: any, b: any) {
  return a * b;
}

export function validateIPaddress(ipaddress: any) {
  if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
    return true
  }
  return false
}

export function getUniquMachineNumbers(equipments: any) {
  let numbers = new Array<any>();
  equipments.map((equipment: any) => {
    let hasBeenAdded = numbers.filter((item: any) => {
      return item.title === equipment.number;
    });
    if (hasBeenAdded.length === 0) {
      numbers.push({ title: equipment.number, selected: false });
    }
    return null;
  });
  return numbers;
};
export function getUniqueNames(equipments: any) {
  let names = new Array<any>();
  equipments.map((equipment: any) => {
    let hasBeenAdded = names.filter((item: any) => {
      return item.title === equipment.name;
    });
    if (hasBeenAdded.length === 0) {
      names.push({ title: equipment.name, selected: false });
    }
    return null;
  });
  return names;
};
export function getUniqueTypes(equipments: any) {
  let names = new Array<any>();
  equipments.map((equipment: any) => {
    let hasBeenAdded = names.filter((item: any) => {
      return item.title === equipment.type;
    });
    if (hasBeenAdded.length === 0) {
      names.push({ title: equipment.type, selected: false });
    }
    return null;
  });
  return names;
};
export function convertToBoolean(value: any) {
  if (value === false) {
    return false;
  }
  if (value === true) {
    return true
  } else {
    return value === "true" ? true : false
  }
}

export function getPositionFromKey(positionKey: any, companyData: any) {
  if (!positionKey) {
    return null;
  }
  if (!companyData) {
    return null;
  }
  let results = companyData.positions.filter((obj: any) => {
    return obj.value === positionKey;
  });
  if (results && results.length > 0) {
    return results[0];
  } else {
    return null;
  }
}